import { useState, useEffect, useCallback } from 'react';

export const useSpeakerDevices = () => {
  const [speakers, setSpeakers] = useState<MediaDeviceInfo[]>([]);
  const [activeSpeakerId, setActiveSpeakerId] = useState<string>();

  const load = useCallback(async () => {
    await navigator.mediaDevices.getUserMedia({ audio: true }).catch(() => {});
    const devices = await navigator.mediaDevices.enumerateDevices();
    const outputs = devices.filter((d) => d.kind === 'audiooutput');
    setSpeakers(outputs);
    if (outputs.length > 0 && !activeSpeakerId) {
      setActiveSpeakerId(outputs[0].deviceId);
    }
  }, [activeSpeakerId]);

  useEffect(() => {
    load();
    navigator.mediaDevices.addEventListener('devicechange', load);
    return () => navigator.mediaDevices.removeEventListener('devicechange', load);
  }, [load]);

  const switchSpeaker = useCallback(async (deviceId: string) => {
    const audioElements = document.querySelectorAll('audio');
    for (const el of Array.from(audioElements)) {
      if ('setSinkId' in el) {
        await (el as any).setSinkId(deviceId).catch(() => {});
      }
    }
    setActiveSpeakerId(deviceId);
  }, []);

  return { speakers, activeSpeakerId, switchSpeaker };
};
